export default __webpack_public_path__ + "assets/models/a4cd225e5094b952453215d98d30f732.glb";